import * as actionsTypes from "./actionTypes";

const getBuildingList = filter => ({
    type: actionsTypes.GET_BUILDING_LIST_REQUEST,
    filter
});

const searchBuildings = searchFields => ({
    type: actionsTypes.BUILDING_SEARCH_REQUEST,
    searchFields
});

const getBuildingData = buildingId => ({
    type: actionsTypes.GET_BUILDING_REQUEST,
    buildingId
});

const createBuilding = buildingData => ({
    type: actionsTypes.CREATE_BUILDING_REQUEST,
    buildingData
});

const editBuilding = (buildingId, buildingData) => ({
    type: actionsTypes.EDIT_BUILDING_REQUEST,
    buildingId,
    buildingData
});

const deleteBuilding = buildingId => ({
    type: actionsTypes.DELETE_BUILDING_REQUEST,
    buildingId
});

const resetBuildingsForm = () => ({
    type: actionsTypes.RESET_BUILDINGS_FORM
});

export default {
    searchBuildings,
    getBuildingData,
    createBuilding,
    editBuilding,
    deleteBuilding,
    resetBuildingsForm,
    getBuildingList
}